const coreStickyHeader = function() {
    var $window = $(window),
        $body = $("body"),
        $pageWrapper = $(".pageWrapper"),
        startPosition = $window.scrollTop(),
        prevScrollDirection = null,
        prevScrollPos = 99999,
        threshold = 500,
        headerHeight = $("header").outerHeight() || 0,
        distSticky = $pageWrapper.length ? $pageWrapper.offset().top : 0;

    $window.on("resize scroll orientationchange", function() {
        var scrollTop = $window.scrollTop(),
            scrollDirection = prevScrollPos < scrollTop ? "down" : "up",
            distScrolled = Math.abs(startPosition - scrollTop);

        prevScrollPos = scrollTop;

        //determines if scroll direction changed since last event fire
        if (scrollDirection !== prevScrollDirection) {
            prevScrollDirection = scrollDirection;
            startPosition = $window.scrollTop();
            distScrolled = 0;
        }

        //conditional to hide or show the header
        if (scrollDirection == "down") {
            //DOWN
            if (scrollTop >= distSticky + headerHeight) {
                //check to make sure the header has passed the sticky distance
                $body.addClass("header-hide");
            }
        } else {
            //UP
            if (scrollTop >= distSticky + headerHeight && distScrolled > threshold) {
                //check to make sure the header has passed the sticky
                $body.addClass("header-sticky").removeClass("header-hide");
            } else if ($body.hasClass("header-hide") && scrollTop < distSticky + headerHeight) {
                $body.removeClass("header-hide header-sticky");
            }

            if (scrollTop < distSticky) {
                $body.removeClass("header-sticky");
            }
        }
    });
};

export default coreStickyHeader;
